/**
 * 활동 예정 시각 표시(FS-01-04 교사 홈 · FS-11-08 교류 룸 초대) — 두 기능이 같이 쓴다.
 */
import type { TeacherActivity } from "./api/fieldApi";
import type { Translate } from "../i18n";

/** 예정 시각(ISO) → '오늘 14:30' · '내일 09:10' · '9월 30일 10:00' — ISO 가 아니면 그대로(옛 응답 '오늘 3교시') */
export function whenLabel(
  a: Pick<TeacherActivity, "scheduledAt" | "when">,
  t: Translate,
  locale: string,
  now = new Date(),
): string | null {
  const raw = a.scheduledAt ?? a.when ?? null;
  if (!raw) return null;
  const ms = /^\d{4}-\d{2}-\d{2}T/.test(raw) ? Date.parse(raw) : NaN;
  if (Number.isNaN(ms)) return raw;
  const d = new Date(ms);
  const time = d.toLocaleTimeString(locale, { hour: "2-digit", minute: "2-digit", hour12: false });
  const day = (x: Date) => new Date(x.getFullYear(), x.getMonth(), x.getDate()).getTime();
  const diff = Math.round((day(d) - day(now)) / 86_400_000);
  if (diff === 0) return t("teacher.home.whenToday", { time });
  if (diff === 1) return t("teacher.home.whenTomorrow", { time });
  return `${d.toLocaleDateString(locale, { month: "long", day: "numeric" })} ${time}`;
}

/** 예정 시각이 없거나 오늘(현지 날짜)인가 */
export function isTodayOrUnset(at: string | null | undefined, now = new Date()): boolean {
  if (!at) return true;
  const d = new Date(at);
  return (
    !Number.isNaN(d.getTime()) &&
    d.getFullYear() === now.getFullYear() &&
    d.getMonth() === now.getMonth() &&
    d.getDate() === now.getDate()
  );
}
